import {CasusStateFilter} from '#/Autocomplete/CasusAutocomplete/CasusAutocomplete.types';
import i18n from '_/i18n';

export const CasusStateTranslation: Record<CasusStateFilter, string> = {
  ACTIVE: i18n.t('casus:label.state.active'),
  ARCHIVED: i18n.t('casus:label.state.archived'),
  INACTIVE: i18n.t('casus:label.state.inactive'),
};

export const casusStateItems: {value: CasusStateFilter; label: string}[] = [
  {
    value: 'ACTIVE',
    label: CasusStateTranslation.ACTIVE,
  },
  {
    value: 'INACTIVE',
    label: CasusStateTranslation.INACTIVE,
  },
  {
    value: 'ARCHIVED',
    label: CasusStateTranslation.ARCHIVED,
  },
];
